import { motion } from "framer-motion";

const StatProgressBar = ({
  labelLeft,
  labelRight,
  value,
  valueRight,
  variant = "single",
}) => {
  const leftValue = value || 0;
  const relativeRightValue = (valueRight * leftValue) / 100;
  return (
    <div className="flex flex-col w-full space-y-1">
      {/* Labels */}
      <div className="flex justify-between text-xs">
        {variant === "single" ? (
          <>
            <span className="text-secondary text-14 capitalize font-medium">
              {labelLeft}
            </span>
            <span className="text-primary text-14 font-medium">{value}%</span>
          </>
        ) : (
          <>
            <span className="text-info font-bold uppercase">
              <span className="text-12">{labelLeft} </span>
              <span className="text-14">{leftValue}%</span>
            </span>
            <span className="text-warning font-bold text-14 uppercase">
              <span className="text-12">{labelRight} </span>
              <span className="text-14">{valueRight}%</span>
            </span>
          </>
        )}
      </div>

      {/* Progress Bar */}
      <div className="relative h-1.5 w-full rounded-full bg-background overflow-hidden">
        {variant === "double" ? (
          <div className="flex relative w-full h-full">
            <motion.div
              className="h-full  bg-info rounded-full absolute left-0 "
              style={{ zIndex: 0 }}
              initial={{ width: 0 }}
              animate={{ width: `${leftValue}%` }}
              transition={{ duration: 0.6, ease: "easeOut" }}
            />
            <motion.div
              className="h-full bg-warning rounded-full absolute left-0 "
              style={{ zIndex: 5 }}
              initial={{ width: 0 }}
              animate={{ width: `${relativeRightValue}%` }}
              transition={{ duration: 0.6, ease: "easeOut" }}
            />
          </div>
        ) : (
          <motion.div
            className="bg-info h-full rounded-full"
            initial={{ width: 0 }}
            animate={{ width: `${value}%` }}
            transition={{ duration: 0.6, ease: "easeOut" }}
          />
        )}
      </div>
    </div>
  );
};

export default StatProgressBar;
